import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ElementRef } from 'react';
import styles from './CustomCheckbox.module.scss';
import CustomText from '../CustomText';

const CustomCheckbox = ({
  name,
  label,
  onChange,
  required,
  value,
  checked,
  readOnly,
  small,
  ref,
}) => {
  return (
    <div className={clsx(styles.input, small && styles.small)}>
      <input
        ref={ref}
        type='checkbox'
        id={name}
        value={value}
        onChange={onChange}
        checked={checked}
        readOnly={readOnly}
      />
      {label && (
        <label htmlFor={name}>
          <CustomText className={styles.checkboxText}>
            {label}
            {required && !value && <span className={styles.required}>*</span>}
          </CustomText>
        </label>
      )}
    </div>
  );
};

CustomCheckbox.propTypes = {
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.bool,
  checked: PropTypes.bool,
  readOnly: PropTypes.bool,
  small: PropTypes.bool,
  ref: PropTypes.shape({ current: PropTypes.instanceOf(ElementRef) }),
};

export default CustomCheckbox;
